import { map } from 'lodash';
import { SUPPORTED_LOCALES } from '@trip-ux/constants';
import { ConfigState, Organization } from '@trip-ux/redux-store';

export const createPayload = (str: string, config: ConfigState): unknown => {
  return { code: str };
};

export const prepareDropList = (searchList: Organization[], config: ConfigState): { label: string; value: string }[] =>
  map(searchList, list => {
    const labelText =
      config.locale === SUPPORTED_LOCALES.ENGLISH ? list.organizationName : list.organizationNameInFrench;
    return { label: `${labelText}, ${list.code}`, value: list.code };
  });
export const prepareDropListBrokerage = (
  searchList: Organization[] = [],
  config: ConfigState
): { label: string; value: string }[] =>
  searchList
    ?.filter(list => list.category === 'BROKERAGE')
    .map(list => {
      const labelText =
        config.locale === SUPPORTED_LOCALES.ENGLISH ? list.organizationName : list.organizationNameInFrench;
      return { label: `${labelText}, ${list.code}`, value: list.code };
    });
